import React from 'react';
import PropTypes from 'prop-types';

import {
  Badge,
  Box,
  Tab
} from '@mui/material';

import TabList from '@mui/lab/TabList';

import {
  documentBadgeSx,
  tabListSx,
  tabsHeaderSx
} from './SoapLeftStyles';

const SoapTabs = ({
  onChange
}) => {
  return (
    <Box sx={tabsHeaderSx}>
      <TabList
        onChange={onChange}
        aria-label="SOAP tabs"
        variant="fullWidth"
        sx={tabListSx}>
        <Tab
          label="SOAP"
          value="1"
        />

        <Tab
          label="Medical Hx Update"
          value="2"
        />

        <Tab
          label="Diagnosis Update"
          value="3"
        />

        <Tab
          value="4"
          label={
            <Badge
              variant="dot"
              color="error"
              overlap="circular"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              sx={documentBadgeSx}>
              <Box component="span">
                PT Document
              </Box>
            </Badge>
          }
        />
      </TabList>
    </Box>
  );
};

SoapTabs.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default SoapTabs;